import { Text } from "@/components/ui/baseUi/text"
import { BoxProgramPrivacyIcon } from "@/modules/boxProgrammation/components/boxProgramPrivacyIcon"
import { useBoxProgram } from "@/modules/boxProgrammation/hooks/useBoxProgram"
import { cn } from "@/modules/lib/utils"
import { BoxRestrictionTag } from "@modules/boxProgrammation/components/boxRestrictionTag"
import { word } from "@modules/core/utils/i18n"

type BoxRestrictionsType = {
  boxProgramId: string
  className?: string
} & React.ComponentProps<"div">

export function BoxRestrictionsComponent({ boxProgramId, className, ...props }: BoxRestrictionsType) {
  const { data: boxProgrammation } = useBoxProgram(boxProgramId)

  if (!boxProgrammation.visibility) {
    return null
  }

  return (
    <div
      className={cn("mt-6 flex w-full rounded-2xl border-2 border-primary-500 bg-neutral-100 p-4", className)}
      {...props}
    >
      <div className="flex flex-row items-center gap-8">
        <BoxProgramPrivacyIcon visibility={boxProgrammation.visibility} isSelected />

        <div className="flex grow flex-col justify-between gap-4">
          <Text fontStyle="BS">{word("box.programmation.activity.explanation1")}</Text>
          <div className="flex flex-wrap items-start gap-3 self-stretch p-1">
            {boxProgrammation.restrictions.map((restriction) => (
              <BoxRestrictionTag
                boxOffer={restriction}
                key={restriction.id}
                isSelected
                textSize={37}
                className="cursor-default"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
